import { IconGeoTag, Text } from '@direct-frontend/components';
import { getOrderTrackingInfo } from '@/entities/order';
// eslint-disable-next-line @direct-frontend/modules/slice-boundaries -- Проблема в текущем файле, тк OrderForm должен быть в widgets
import { mapSubmitButtonRender } from '@/features/MapSubmitButton';
// eslint-disable-next-line @direct-frontend/modules/slice-boundaries, @direct-frontend/modules/entry-point -- Нужно поправить
import { PickupAddressPicker } from '@/features/PickupAddressPicker/PickupAddressPicker';
// eslint-disable-next-line @direct-frontend/modules/slice-boundaries, @direct-frontend/modules/entry-point -- Нужно поправить
import type { PickupAddressValue } from '@/features/PickupAddressPicker/types/PickupAddressValue';
import { type OrderDto } from '@/shared/api/order';
import { ServiceTypeIcon } from '@/shared/components/ServiceTypeIcon';
import { Trigger, type TriggerProps } from '@/shared/components/Trigger';
import { reinitializeOrderForm } from '../../lib/reinitializeOrderForm';
import { type PickupAddressFieldValue } from '../../model/forms/fieldPickupAddress';

type PickupAddressInputProps = TriggerProps & {
    order: OrderDto;
    storeSlug: string;
    defaultLocation: string;
    locality: string;
    value?: PickupAddressFieldValue;
    onChange?: (address: PickupAddressValue) => void;
    validationState?: 'valid' | 'invalid';
} & Pick<TriggerProps, 'caption' | 'rightContent'>;

export const PickupAddressInput = (props: PickupAddressInputProps) => {
    const { order, storeSlug, value, defaultLocation, locality, caption, rightContent, onChange, ...other } = props;

    const serviceLogo =
        value?.serviceType && value.pickupPointId ? (
            <ServiceTypeIcon serviceType={value.serviceType} size="24" />
        ) : undefined;

    const trackingInfo = value?.serviceType && value.pickupPointId ? getOrderTrackingInfo(value.serviceType) : '';

    return (
        <PickupAddressPicker
            value={value}
            defaultLocation={defaultLocation}
            order={order}
            storeSlug={storeSlug}
            locality={locality}
            reinitializeOrderForm={reinitializeOrderForm}
            submitButton={mapSubmitButtonRender({
                order,
            })}
            onChange={onChange}
        >
            {({ onOpenModal }) => (
                <Trigger
                    {...other}
                    iconLeft={<IconGeoTag size="24" />}
                    iconRight={!rightContent && serviceLogo}
                    rightContent={rightContent}
                    caption={caption ?? trackingInfo}
                    onClick={onOpenModal}
                >
                    <Text size="mc">{value?.address || ''}</Text>
                </Trigger>
            )}
        </PickupAddressPicker>
    );
};
